import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/resources',
  component: Layout,
  name: 'resources',
  redirect: '/resources/index',
  children: [{
    path: '/resources/index',
    component: () => import('@/views/resources/index'),
    name: 'resources.index',
    meta: {
      title: i18n.t(`message.resourcesText`)
    }
  }, ]
}

export default paymentType